import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage'

var fbConfig = {
    apiKey: "AIzaSyCchAX9pst2ZkcKKTaQcaRpoEBzff5D_P8",
    authDomain: "immconnect.firebaseapp.com",
    databaseURL: "https://immconnect.firebaseio.com",
    projectId: "immconnect",
    storageBucket: "immconnect.appspot.com",
    messagingSenderId: "711693465984",
    appId: "1:711693465984:web:3f5c9210e3092c5946a965",
    measurementId: "G-GR7ZB0P4QT"
};

// Initialize Firebase
firebase.initializeApp(fbConfig);

const storage = firebase.storage()

export  {
    storage, firebase as default
}